import { Component, type ReactNode } from 'react';
import { Button, EmptyState } from './primitives';

/**
 * What a page shows when drawing it threw, instead of the blank window React leaves behind.
 *
 * The failure itself is reported by the root's `onCaughtError` (`main.tsx`), not here, so a render
 * error is told once however it ends. Reload is the way out because the page's state is what broke.
 */
export class PageCrash extends Component<{ children: ReactNode }, { crashed: boolean }> {
  override state = { crashed: false };

  static getDerivedStateFromError(): { crashed: boolean } {
    return { crashed: true };
  }

  override render(): ReactNode {
    if (!this.state.crashed) return this.props.children;
    return (
      <div style={{ padding: 24 }}>
        <EmptyState
          title="This page stopped working"
          body="We have been told. Reloading usually brings it back."
          action={<Button onClick={() => window.location.reload()}>Reload</Button>}
        />
      </div>
    );
  }
}
